export function RGBToHex(rgbString:string) {
	if (rgbString === undefined) {
		return '';
	}
	
	rgbString = rgbString.replace(/\s/g, '');

	if (rgbString.includes('rgba')) {
		rgbString.replace('rgba', 'rgb');
	}
	
	if (!rgbString || !rgbString.includes('rgb')) {
		return rgbString;
	}
	
	// Choose correct separator
	let sep = rgbString.indexOf(",") > -1 ? "," : " ";
	// Turn "rgb(r,g,b)" into [r,g,b]
	let rgb = rgbString.split('(')[1].split(")")[0].split(sep);

	if (rgb.length === 4 && rgb[3] === '0') {
		return 'transparent';
	}
	
	let r = (+rgb[0]).toString(16),
		g = (+rgb[1]).toString(16),
		b = (+rgb[2]).toString(16);

	if (r.length == 1)
		r = "0" + r;
	if (g.length == 1)
		g = "0" + g;
	if (b.length == 1)
		b = "0" + b;

	return "#" + r + g + b;
}